function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8645"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8306",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8644",
    transform: "translate(8467 18421.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8305",
    width: 51.742,
    height: 21.372,
    rx: 8,
    transform: "translate(-8464 -18415)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8643"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41427",
    d: "M1113.607-1363.289c0-.643-.026-1.288 0-1.93a2.41 2.41 0 0 0-1.468-2.456 5.422 5.422 0 0 1-2.615-2.49c-.147-.3-.283-.609-.426-.913-.727-1.547-1.45-3.095-2.182-4.639a2.717 2.717 0 0 1 .513-3.227c.234-.26.467-.523.686-.8a2.957 2.957 0 0 0 .662-2.248 2.067 2.067 0 0 1 2.374-2.286.917.917 0 0 1 .133.67q.007 2.807 0 5.615a1.037 1.037 0 0 0 .372.936c.247.179.363.13.4-.169a3.52 3.52 0 0 0 .009-.438v-5.7a.9.9 0 0 1 .131-.67v-13.521a2.317 2.317 0 0 1 2.308-2.369 2.292 2.292 0 0 1 2.347 2.319c.009 3.19 0 6.38 0 9.57v.482a2.452 2.452 0 0 1 3-1.587 2.181 2.181 0 0 1 1.5 1.309 6.749 6.749 0 0 1 .192 2c.858-1.493 1.743-2.048 2.834-1.747 1.014.28 1.884.956 1.877 2.824a3.444 3.444 0 0 1 .6-.927 1.922 1.922 0 0 1 2.186-.406 1.948 1.948 0 0 1 1.238 1.9c.022 1.9.007 3.8.007 5.707 0 2.107-.034 4.215.011 6.321a17.353 17.353 0 0 1-.646 5.059 11.484 11.484 0 0 0-.427 2.979c0 .276-.049.551-.076.827z",
    transform: "translate(-9536.306 -17002.639)",
    style: {
      fill: "#eab4ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41428",
    d: "M1143.561-1276.052v6.876c0 .135.071.312-.094.4s-.3 0-.443-.1a1.023 1.023 0 0 1-.519-.936c.011-2.161.007-4.321.007-6.482a3.2 3.2 0 0 1 1.049.242z",
    transform: "translate(-9567.67 -17110.621)",
    style: {
      fill: "#dda97d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41429",
    d: "M1164.058-1463.484c0-.715.009-1.431 0-2.145 0-.245.069-.321.319-.328 1-.027 1-.036 1 .955 0 1.211-.007 2.423.005 3.634 0 .262-.065.349-.34.353-.98.013-.98.024-.98-.936q-.004-.767-.004-1.533z",
    transform: "translate(-9586.49 -16944.957)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41430",
    d: "M1108.927-1440.381c-.056.068-.1.125-.148.176-.185.188-.38.366-.555.562-.14.157-.24.151-.389 0-1.029-1.04-2.066-2.072-3.1-3.107-.031-.031-.087-.061-.089-.094-.02-.446.436-.544.626-.841.085-.133.189-.2.346-.042 1.05 1.061 2.108 2.113 3.162 3.17.05.05.09.108.147.176z",
    transform: "translate(-9534.602 -16964.301)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41431",
    d: "M1083.911-1382.82c-.7 0-1.4-.009-2.1 0-.258.005-.354-.062-.359-.341-.016-.981-.028-.98.943-.98 1.184 0 2.367.01 3.551-.007.33 0 .459.067.451.43-.019.893 0 .893-.9.893z",
    transform: "translate(-9514.337 -17016.423)",
    style: {
      fill: "#0d98bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41432",
    d: "M1219.672-1382.01c-.7 0-1.4-.01-2.107.005-.27.006-.346-.086-.351-.351-.019-.971-.028-.971.952-.971 1.2 0 2.4.01 3.6-.007.309 0 .395.089.393.4-.006.928.007.928-.907.928z",
    transform: "translate(-9632.919 -17017.131)",
    style: {
      fill: "#0c97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41433",
    d: "M1204.368-1443.872a3.669 3.669 0 0 0 .49.573c.364.283.307.477-.006.777-.949.907-1.874 1.842-2.788 2.785-.239.247-.377.306-.643.02-.6-.644-.616-.628.018-1.262l2.6-2.6c.081-.081.17-.152.329-.293z",
    transform: "translate(-9618.733 -16964.254)",
    style: {
      fill: "#0c97bb"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.1c4215773e4847e4c479d02c20ed1ce9.svg";
export { ForwardRef as ReactComponent };